var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.89.293a2.252 2.252 0 012.22 0l9.75 5.525A2.25 2.25 0 0124 7.775v9.5a2.25 2.25 0 01-2.25 2.25H2.25A2.25 2.25 0 010 17.276v-9.5c0-.81.435-1.557 1.14-1.957L10.89.293zm1.48 1.305a.75.75 0 00-.74 0l-9.316 5.28 7.41 4.233a3.75 3.75 0 014.553 0l7.41-4.234-9.317-5.28zm8.28 16.428l-7.26-5.704a2.25 2.25 0 00-2.78 0l-7.26 5.704h17.3zM22.5 8.14l-6.95 3.97 6.663 5.237c.089.07.161.159.21.26a.745.745 0 00.077-.331V8.14zM8.45 12.11L1.5 8.14v9.136c0 .119.028.23.076.33a.744.744 0 01.21-.26l6.664-5.235z"
  })));
}

export default SvgNotificationEnvelope;